var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "fill-height text-center px-3 pb-2" },
    [
      _vm._l(_vm.products, function (product, i) {
        return _c(
          "v-col",
          { key: i, staticClass: "pa-0", attrs: { cols: "12" } },
          [
            _c(
              "v-row",
              { staticClass: "px-3 pb-2" },
              [
                _c(
                  "v-col",
                  { staticClass: "pb-0", attrs: { cols: "12" } },
                  [
                    _c("v-autocomplete", {
                      staticStyle: { "font-size": "15px" },
                      attrs: {
                        items: _vm.productsToSelect[i],
                        value: product.id,
                        label: `Producto ${i + 1}`,
                        readonly:
                          _vm.isReadOnly || _vm.isProductDeleted(product.id),
                        rules: [_vm.$rules.REQUIRED],
                        "item-text": "name",
                        "item-value": "id",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.changeProductsToSelect(i, $event)
                        },
                      },
                      model: {
                        value: product.id,
                        callback: function ($$v) {
                          _vm.$set(product, "id", $$v)
                        },
                        expression: "product.id",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.getProductsMap[product.id] &&
                _vm.getProductsMap[product.id].attributes &&
                _vm.getProductsMap[product.id].attributes.length
                  ? _c(
                      "v-col",
                      { staticClass: "py-0", attrs: { cols: "12" } },
                      [
                        _c(
                          "v-row",
                          _vm._l(
                            _vm.getProductsMap[product.id].attributes,
                            function (attribute, attributeInd) {
                              return _c(
                                "v-col",
                                { key: attribute.id, attrs: { cols: "3" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      value:
                                        product.attributes &&
                                        product.attributes[attributeInd]
                                          ? product.attributes[attributeInd]
                                              .value
                                          : "",
                                      items: attribute.options,
                                      label: attribute.name,
                                      rules: [_vm.$rules.REQUIRED],
                                      readonly:
                                        _vm.isReadOnly ||
                                        _vm.isProductDeleted(product.id),
                                      placeholder: "Seleccione",
                                      "item-text": "name",
                                      "item-value": "name",
                                      "return-object": "",
                                    },
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeAttributeOption(
                                          $event,
                                          i,
                                          attribute.id
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-col",
                  { attrs: { cols: "4", sm: "2" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        rules: [
                          _vm.$rules.NUMBER,
                          _vm.$rules.GREATER_THAN_ZERO,
                        ],
                        readonly:
                          _vm.isReadOnly || _vm.isProductDeleted(product.id),
                        label: "Cantidad",
                        placeholder: "0",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.updateSubtotal(i)
                        },
                      },
                      model: {
                        value: product.quantity,
                        callback: function ($$v) {
                          _vm.$set(product, "quantity", _vm._n($$v))
                        },
                        expression: "product.quantity",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-col",
                  { attrs: { cols: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        rules: [
                          _vm.$rules.REQUIRED,
                          _vm.$rules.CURRENCY,
                          _vm.$rules.GREATER_THAN_ZERO,
                        ],
                        prefix: _vm.$currency.symbol,
                        readonly:
                          _vm.isReadOnly || _vm.isProductDeleted(product.id),
                        label: "Precio",
                        placeholder: "0",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.updateSubtotal(i)
                        },
                      },
                      model: {
                        value: product.price,
                        callback: function ($$v) {
                          _vm.$set(product, "price", _vm._n($$v))
                        },
                        expression: "product.price",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-col",
                  { attrs: { cols: "4" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        value: _vm.$formatCurrency(product.subtotal, false),
                        prefix: _vm.$currency.symbol,
                        readonly: true,
                        label: "Subtotal",
                        placeholder: "0",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.isReadOnly ||
                (_vm.getOrder &&
                  _vm.getOrder.delivery_state !== "pedido-entregado")
                  ? _c(
                      "v-col",
                      {
                        staticClass: "text-right my-auto",
                        attrs: { cols: "4", sm: "1" },
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: { icon: "", small: "" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeProduct(i)
                                              },
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v(" far fa-trash-alt ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c("span", [_vm._v("Eliminar producto")]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-col",
                  { staticClass: "mt-2", attrs: { cols: "12" } },
                  [_c("v-divider")],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.products && _vm.products.length
        ? _c(
            "v-col",
            { staticClass: "pa-0 pb-4", attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "px-3" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0 text-right",
                      attrs: { cols: "4", sm: "6" },
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass:
                            "my-auto pt-5 font-weight-bold grey--text text--darken-2",
                        },
                        [_vm._v("Descuento:")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { staticClass: "py-0", attrs: { cols: "4", sm: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          rules: [_vm.$rules.CURRENCY],
                          readonly: _vm.isReadOnly,
                          suffix: "%",
                        },
                        model: {
                          value: _vm.discountToApply,
                          callback: function ($$v) {
                            _vm.discountToApply = _vm._n($$v)
                          },
                          expression: "discountToApply",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "px-3" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0 text-right",
                      attrs: { cols: "4", sm: "6" },
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass:
                            "my-auto pt-5 font-weight-bold grey--text text--darken-2",
                        },
                        [_vm._v("Total productos:")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { staticClass: "py-0", attrs: { cols: "4", sm: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.$formatCurrency(_vm.totalProducts, false),
                          readonly: true,
                          prefix: _vm.$currency.symbol,
                          placeholder: "0",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "px-3" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0 text-right",
                      attrs: { cols: "4", sm: "6" },
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass:
                            "my-auto pt-5 font-weight-bold grey--text text--darken-2",
                        },
                        [_vm._v("Total delivery:")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { staticClass: "py-0", attrs: { cols: "4", sm: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.$formatCurrency(_vm.totalDelivery, false),
                          readonly: true,
                          prefix: _vm.$currency.symbol,
                          placeholder: "0",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "px-3" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0 text-right",
                      attrs: { cols: "4", sm: "6" },
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass:
                            "my-auto pt-5 font-weight-bold grey--text text--darken-2",
                        },
                        [_vm._v("Total a pagar:")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { staticClass: "py-0", attrs: { cols: "4", sm: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.$formatCurrency(
                            _vm.totalProducts + _vm.totalDelivery,
                            false
                          ),
                          readonly: true,
                          prefix: _vm.$currency.symbol,
                          placeholder: "0",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c("v-col", { attrs: { cols: "12" } }, [
            _c("h5", { staticClass: "font-weight-thin text--secondary" }, [
              _vm._v("No hay productos asociados"),
            ]),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }